import { ColouredText } from './Styled'

const ColouredTextItems = ({ colouredTextItems, domain }) => {
  const showNoFollow = domain === 'housekeeper.com'

  if (!colouredTextItems) {
    return null
  } else {
    return (
      colouredTextItems &&
      colouredTextItems.length > 0 &&
      colouredTextItems.map((item) => (
        <ColouredText
          href={`https://${item.url}`}
          key={item.url}
          color={item.color}
          rel={showNoFollow ? 'nofollow' : ''}
        >
          {item.title}
        </ColouredText>
      ))
    )
  }
}

export default ColouredTextItems
